import styled from "styled-components";
import { colors } from "@/theme";

export const CartItemToShipCheckboxContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto auto auto;
  justify-items: center;
  align-items: center;
  column-gap: 24px;
  padding: 4px 16px;
  border: ${`1px solid ${colors.black}`};
  border-radius: 12px;
`;

export const CartItemToShipCheckboxCheckbox = styled.div``;

export const CartItemToShipCheckboxProduct = styled.div``;

export const CartItemToShipCheckboxOrderQuantity = styled.div``;

export const CartItemToShipCheckboxShippingQuantity = styled.div``;
